import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import * as LanguageUtils from "../Utils/LanguageUtils";
import * as CustomEvents from "../Constants/CustomEvents";
import * as StorageKeys from "../../middleware/Constants/StorageKeys";

import EnglishLanguageStrings from "../../assets/Languages/en.json"
import LogService from "../../middleware/CommonSdk/LogService";

const languagesUrl = "/Languages/";
const LOG_TAG = "LANGUAGE";
const EnglishLanguage = "en";


export const LanguageContext = React.createContext({
    availableLocaleList: {},
    setLocale: (languageCode) => { }
});

const LanguageContextProvider = props => {
    const [selectedLocale, setSelectedLocale] = useState(EnglishLanguage);
    const [localeStrings, setLocaleStrings] = useState(EnglishLanguageStrings);
    const [availableLocaleList, setAvailableLocaleList] = useState({});

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect didmount");
        const userLanguage = findLanguage();
        handleSetLocale(userLanguage);

        function storageEventHandler(event) {
            LogService.info(LOG_TAG, "useEffect didmount storageEventHandler");
            const storedLanguage = findLanguage();
            handleSetLocale(storedLanguage);
        };

        document.addEventListener(CustomEvents.CUSTOM_EVENT_SESSION_STORAGE, storageEventHandler);
        return () => {
            document.removeEventListener(CustomEvents.CUSTOM_EVENT_SESSION_STORAGE, storageEventHandler);
        };
    }, []);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect selectedLocale");

        let foundLanguageList = {};
        LanguageUtils.getAvailableLanguageCodes().map(countryCode => {
            let languageTranslation = localeStrings[countryCode];
            foundLanguageList = { ...foundLanguageList, [countryCode]: languageTranslation };
        });
        setAvailableLocaleList(foundLanguageList);
    }, [selectedLocale]);

    const handleSetLocale = (languageCode) => {
        LogService.trace(LOG_TAG, "handleSetLocale langage", languageCode);

        let localeMessages = EnglishLanguageStrings;
        let countryCode = EnglishLanguage;
        if (languageCode && languageCode !== EnglishLanguage) {
            localeMessages = getLocaleStrings(languageCode)
            setUserLanguageToSessionStorage(languageCode);
            countryCode = languageCode;
        }
        setLocaleStrings(localeMessages);
        setSelectedLocale(countryCode);
    }

    const findLanguage = () => {
        const storageLanguage = getUserLanguageFromSessionStorage();
        LogService.info(LOG_TAG, "findLanguage storageLanguage:", storageLanguage);

        let candidateLanguage = EnglishLanguage;
        if (storageLanguage != null)
            candidateLanguage = storageLanguage;
        else {
            candidateLanguage = navigator.language.split("-")[0];
            LogService.info(LOG_TAG, "findLanguage browserLanguage:", candidateLanguage);
        }

        let foundLanguage = EnglishLanguage;
        const localeKeysList = LanguageUtils.getAvailableLanguageCodes();
        const foundIndex = localeKeysList.indexOf(candidateLanguage);
        if (foundIndex >= 0)
            foundLanguage = localeKeysList[foundIndex];

        LogService.info(LOG_TAG, "findLanguage foundLanguage:", foundLanguage);
        return foundLanguage;
    }

    const getUserLanguageFromSessionStorage = () => {
        return sessionStorage.getItem(StorageKeys.STORAGE_KEY_LANGUAGE);
    }

    const setUserLanguageToSessionStorage = (languageCode) => {
        sessionStorage.setItem(StorageKeys.STORAGE_KEY_LANGUAGE, languageCode);
    }

    const clearLanguageToSessionStorage = () => {
        sessionStorage.removeItem(StorageKeys.STORAGE_KEY_LANGUAGE);
    }

    const getLocaleStrings = (languageCode) => {
        let url = languagesUrl + languageCode + ".json";
        let localeMessages = {};
        try {
            localeMessages = require("../../assets" + url);
        } catch (error) {
            LogService.error(LOG_TAG, "error while loading ", "../../assets" + url);
        }
        return Object.assign({}, EnglishLanguageStrings, localeMessages);
    }

    LogService.info(LOG_TAG, "render", selectedLocale);

    return (
        <LanguageContext.Provider value={{ availableLocaleList: availableLocaleList, setLocale: handleSetLocale }}>
            <IntlProvider locale={selectedLocale} messages={localeStrings}>
                {props.children}
            </IntlProvider>
        </LanguageContext.Provider>
    )
}

export default LanguageContextProvider;